








import { Vue, Component } from "vue-property-decorator";
import axios from "axios"
import AsideUpdatesItem from "./AsideUpdatesItem.vue"

@Component({
  name: 'AsideUpdates',
  components: { AsideUpdatesItem }
})
export default class AsideUpdates extends Vue {
  items = [];

  mounted() {
    this.getData()
  }

  getData() {
    // axios
    //   .get('/data-sources/updates.json')
    //   .then(r => {
    //     this.items = r.data.data
    //     this.$emit('data-updated')

    //     this.$store.commit('basic', {
    //       key: 'hasUpdates',
    //       value: true
    //     })
    //   })
    //   .catch(err => {
    //     this.$buefy.toast.open({
    //       message: `Error: ${err.message}`,
    //       type: 'is-danger'
    //     })
    //   })
  }
}
